// JAVASCRIPT LAYER [APP.JS]  =========================================================================================

function TipiThemeGetCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

// Blog Filters
function filterblog(e) {
    if(e === '*'){
        jQuery('.m-filter-results').isotope({ filter: e });
        jQuery('.m-articles').isotope({ filter: e });

    }
    else {
        jQuery('.m-filter-results').isotope({ filter: '.'+e });
        jQuery('.m-articles').isotope({ filter: '.'+e });

    }
}

function filteramenity() {
    jQuery(this).parent().addClass('active-filter');
}

function IE_polyfill() {
    // IE OBJECT FIT POLYFILL
    this.fitie=function(t){function e(){c.call(t,g+m,e);var a={boxSizing:"content-box",display:"inline-block",overflow:"hidden"};"backgroundColor backgroundImage borderColor borderStyle borderWidth bottom fontSize lineHeight height left opacity margin position right top visibility width".replace(/\w+/g,function(t){a[t]=l[t]}),d.border=d.margin=d.padding=0,d.display="block",d.height=d.width="auto",d.opacity=1;var h=t.videoWidth||t.width,s=t.videoHeight||t.height,u=h/s,v=document.createElement("object-fit");v.appendChild(t.parentNode.replaceChild(v,t));for(var p in a)v.runtimeStyle[p]=a[p];var b;"fill"===i?f?(d.width=o,d.height=n):(d["-ms-transform-origin"]="0% 0%",d["-ms-transform"]="scale("+o/h+","+n/s+")"):(r>u?"contain"===i:"cover"===i)?(b=n*u,d.width=Math.round(b)+"px",d.height=n+"px",d.marginLeft=Math.round((o-b)/2)+"px"):(b=o/u,d.width=o+"px",d.height=Math.round(b)+"px",d.marginTop=Math.round((n-b)/2)+"px")}var i=t.currentStyle["object-fit"];if(i&&/^(contain|cover|fill)$/.test(i)){var o=t.clientWidth,n=t.clientHeight,r=o/n,a=t.nodeName.toLowerCase(),d=t.runtimeStyle,l=t.currentStyle,h=t.addEventListener||t.attachEvent,c=t.removeEventListener||t.detachEvent,g=t.addEventListener?"":"on",f="img"===a,m=f?"load":"loadedmetadata";h.call(t,g+m,e),t.complete&&e()}},this.fitie.init=function(){if(document.body)for(var t=document.querySelectorAll("img,video"),e=-1;t[++e];)fitie(t[e]);else setTimeout(fitie.init)},/MSIE|Trident/.test(navigator.userAgent)&&this.fitie.init();
}

if (!String.prototype.padStart) {
  Object.defineProperty(String.prototype, 'padStart', {
    configurable: true,
    writable: true,
    value: function (targetLength, padString) {
      targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
      padString = String(typeof padString !== 'undefined' ? padString : ' ');
      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
          padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
        }
        return padString.slice(0, targetLength) + String(this);
      }
    },
  });
}

jQuery(document).ready(function($) {

// IE_polyfill();


jQuery('.m-sub-menu li a.is-active').parents('li').addClass('is-active'); // ​

// jQuery('.amenity-filter').click(function(){
//
//     var filterby = jQuery(this).data('filter');
//
//     jQuery('.m-filters ul li').removeClass('active');
//     jQuery(this).parent().addClass('active');
//
//     if(filterby === '*'){
//         jQuery('.m-filter-results').isotope({ filter: filterby });
//         jQuery('.m-articles').isotope({ filter: filterby });
//
//     }
//     else {
//         jQuery('.m-filter-results').isotope({ filter: '.'+filterby });
//         jQuery('.m-articles').isotope({ filter: '.'+filterby });
//
//     }
//
//     setTimeout(function(){
//         amenity_load_more();
//         jQuery('.a-load-more').click();
//         console.log('showall');
//     }, 50);
// });
